import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import Header from "../components/Header";
import PasswordInput from "../components/PasswordInput";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = sp.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("As senhas não coincidem");
    if (password.length < 6) return toast.error("Senha muito curta");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Senha redefinida com sucesso!");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-28 max-w-md mx-auto px-4">
        <Card className="p-8 gold-border">
          <h1 className="font-display text-3xl font-bold">Redefinir <span className="gold-text">senha</span></h1>
          {!token ? (
            <p className="mt-4 text-sm text-muted-foreground">Link inválido. Solicite um novo em <Link to="/esqueci-senha" className="gold-text">Esqueci a senha</Link>.</p>
          ) : (
            <form className="mt-6 space-y-4" onSubmit={submit}>
              <div>
                <Label htmlFor="pwd">Nova senha</Label>
                <PasswordInput id="pwd" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" />
              </div>
              <div>
                <Label htmlFor="cpwd">Confirmar nova senha</Label>
                <PasswordInput id="cpwd" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm" />
              </div>
              <Button type="submit" disabled={loading} className="gold-btn w-full" data-testid="reset-submit">
                {loading ? "Salvando..." : "Salvar nova senha"}
              </Button>
            </form>
          )}
        </Card>
      </div>
    </div>
  );
}
